import React from 'react';
import PropTypes from 'prop-types';
import theme from 'theme/theme';

const MessageField = (props) => {
    const { children, additional, style } = props;

    return (
        <div style={ Object.assign(style, additional) }>
            { children }
        </div>
    );
};

MessageField.defaultProps = {
    additional: {},
    style: {
        backgroundColor: theme.palette.wildSand,
        border: `1px solid ${ theme.palette.silver }`,
        margin: '0 0 0.5rem 0',
        position: 'relative',
        padding: '10px 16px',
    },
};

MessageField.propTypes = {
    additional: PropTypes.object,
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.element,
        PropTypes.object,
        PropTypes.string,
    ]),
    style: PropTypes.object,
};

export default MessageField;



// WEBPACK FOOTER //
// ./src/components/field/MessageField/MessageField.js